// extracted by mini-css-extract-plugin
export default {"titleContainer":"Card_titleContainer__bmlLB","bodyContainer":"Card_bodyContainer__KHEkx"};